import * as React from 'react';

const LogoSoundcloudSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M7 17.939H6V9.871a4.099 4.099 0 011-.566v8.634zm3 0h1V8.715a5.576 5.576 0 00-.621.857L10 9.388v8.551zm-2 0h1V9.091c-.508-.079-.623-.05-1-.01v8.858zm-4 0h1v-7.02a4.69 4.69 0 00-.692 1.535L4 12.272v5.667zm-3-5.25c-.606.547-1 1.354-1 2.268 0 .914.394 1.721 1 2.268v-4.536zm18.879-.671c-.204-2.837-2.404-5.079-5.117-5.079A4.846 4.846 0 0012 7.816v10.123h9.089c1.607 0 2.911-1.393 2.911-3.106 0-2.233-2.168-3.772-4.121-2.815zM3 11.991c-.302-.024-.526-.03-1 .122v5.689c.446.143.636.138 1 .138v-5.949z" />
    </svg>
);

LogoSoundcloudSvg.displayName = 'LogoSoundcloudSvg';
export default LogoSoundcloudSvg;
